
import React, { useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";
import "../../styles/SideNavBar.css";
// import { useSelector } from "react-redux";

// MENU_ITEMS (equivalent of your interface)
export const MENU_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    Icon: Feather.Airplay,
    url: "/admin/dashboard",
  },
  // {
  //   key: "cart",
  //   label: "Cart",
  //   url: "/admin/Cart",
  //   Icon: Feather.ShoppingCart,
  // },

  {
    key: "category",
    label: "Category",
    url: "/admin/category",
    Icon: Feather.Grid,
  },
  {
    key: "customer",
    label: "Customers",
    Icon: Feather.Users,
    url: "/admin/customer",
  },
  {
    key: "gold rate",
    label: "Gold Rate",
    Icon: Feather.DollarSign,
    url: "/admin/gold-rate",
  },
  {
    key: "product",
    label: "Product",
    Icon: Feather.Box,
    url: "/admin/product",
  },
  // {
  //   key: "productImage",
  //   label: "ProductImage",
  //   Icon: Feather.Image,
  //   url: "/admin/productImage",
  // },
  // {
  //   key: "order",
  //   label: "Order",
  //   Icon: Feather.Truck,
  //   url: "/admin/order",
  // },
  // {
  //   key: "orderItems",
  //   label: "OrderItems",
  //   Icon: Feather.FileText,
  //   url: "/admin/order-items",
  // },
  {
    key: "OrderManagement",
    label: "Order Management",
    Icon: Feather.FileText,
    url: "/admin/order-management",
  },
  {
    key: "vendor",
    label: "Vendor",
    Icon: Feather.Briefcase,
    url: "/admin/vendor",
  },
];

const SideNavBarAdmin = () => {
  // const authUser = useSelector((state) => state.authUser);

  const renderMenuItem = (menuItem) => {
    const { Icon } = menuItem;
    return (
      <li className="nav-item" key={menuItem.key}>
        <Link to={menuItem.url || ""} className="nav-link">
          {Icon && <Icon style={{ marginRight: "5px" }} />}
          <p>{menuItem.label}</p>
        </Link>
      </li>
    );
  };

  return (
    <aside
      className="main-sidebar elevation-4"
      style={{ background: "rgb(0,0,0)", position: "fixed" }}
    >
      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="info">
            <img
              src="/img/logo.png"
              height="50px"
              width="200px"
              alt="uniquejewellary"
            />
          </div>
          <hr></hr>
        </div>
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            data-accordion="false"
          >
            {MENU_ITEMS.map((menuItem) =>
              menuItem.children ? (
                <MenuItem key={menuItem.key} menuItem={menuItem} />
              ) : (
                renderMenuItem(menuItem)
              )
            )}
            {/* <li className="nav-item">
              <Link to="/logout" className="nav-link">
                <Feather.LogOut style={{ marginRight: "5px" }} />
                <p>Logout</p>
              </Link>
            </li> */}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

const MenuItem = ({ menuItem }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const { Icon } = menuItem;

  const handleToggleMenuClick = (e) => {
    e.preventDefault();
    setShowSubMenu(!showSubMenu);
  };

  return (
    <li className="nav-item" key={menuItem.key}>
      <Link
        to="#"
        className="nav-link"
        onClick={handleToggleMenuClick}
        aria-expanded={showSubMenu}
      >
        {Icon && <Icon style={{ marginRight: "5px" }} />}
        <p>
          {menuItem.label}
          <i
            className={`right fas ${
              !showSubMenu ? "fa-angle-left" : "fa-angle-down"
            }`}
          ></i>
        </p>
      </Link>
      <ul
        className="nav nav-treeview"
        style={{ display: showSubMenu ? "block" : "none" }}
      >
        {menuItem.children?.map((childItem) => (
          <li className="nav-item" key={childItem.key}>
            <Link to={childItem.url || "#"} className="nav-link">
              <i className="fas fa-angle-right nav-icon"></i>
              <p>{childItem.label}</p>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default SideNavBarAdmin;
